const addToCartValidation = require('core/product/addToCartValidation');
const isMobile = window.innerWidth < 992;
var Swiper = require('swiper/swiper-bundle');

window.jQuery = require('jquery');
require('owl.carousel');

// let updatedPid = '';
// const isCart = document.querySelector('.cart-body-section');

function updateSizeSelectorSizing() {
  var header = $('#size-selector-modal .widget-product-details .modal-header').length > 0 ? $('#size-selector-modal .widget-product-details .modal-header')[0].clientHeight + 44 + 24 + 40 : 0;
  var content = $('#size-selector-modal .widget-product-details .modal-content').length > 0 ?  $('#size-selector-modal .widget-product-details .modal-content')[0].clientHeight + 40 : 0;
  var sizeGuideBox = $('#size-selector-modal .size-guidelines-trigger-box').length > 0 ?  $('#size-selector-modal .size-guidelines-trigger-box')[0].clientHeight + 20 : 0;
  var modalContent = $('#size-selector-modal .pdp-size-picker-container-selector').length > 0 ? $('#size-selector-modal .pdp-size-picker-container-selector')[0] : 0;
  var sizeLocaleSelector = $('#size-selector-modal .size-locale-selector').length > 0 ? $('#size-selector-modal .size-locale-selector')[0].clientHeight + 16 : 0;
  var addToCart = $('#size-selector-modal .widget-product-details .add-to-cart-actions').length > 0 ?   $('#size-selector-modal .widget-product-details .add-to-cart-actions')[0].clientHeight + 32 : 0;
  var findInStore = $('#size-selector-modal .findinstore').length > 0 ? $('#size-selector-modal .findinstore')[0].clientHeight + 16 : 0;

  $('#size-selector-modal .widget-product-details .modal-content')[0].style.height = 'calc(100svh' + ' - ' + header + 'px)';
  if ($('.product-size-message-warning.visually-hidden').length > 0) {
    modalContent.style.height = 'calc(100svh' + ' - ' + (header + sizeGuideBox + sizeLocaleSelector + findInStore + addToCart) + 'px)';
  } else {
    var warningSizeWrapper = $('.product-size-message-warning')[0].clientHeight + 13;
    modalContent.style.height = 'calc(100svh' + ' - ' + (header + sizeGuideBox + warningSizeWrapper + findInStore + sizeLocaleSelector + addToCart) + 'px)';
  }

}

function updateBodyScrollability() {
  var scrollTop = $('.scroll-distance').data('scrolledDistance');
  let html = document.getElementsByTagName('html')[0];
  html.setAttribute("style", "overflow-y: scroll; position: unset; width:100%; height: 100vh;");
  if (scrollTop) {
    window.scrollTo(0, scrollTop);
  }
}

/**
 * updates the product view when a product attribute is selected or deselected or when
 *         changing quantity
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {jQuery} $productContainer - DOM element for current product
 */
function attributeSelect(selectedValueUrl, $productContainer) {
  if (selectedValueUrl) {
    $('body').trigger('product:beforeAttributeSelect', { url: selectedValueUrl, container: $productContainer });
    $.ajax({
      url: selectedValueUrl,
      method: 'GET',
      success: function (data) {
        // if(data.product.id) {
        //   updatedPid = data.product.id;
        // }
        handleVariantResponse(data, $productContainer);
        //updateOptions(data.product.optionsHtml, $productContainer);
        //updateQuantities(data.product.quantities, $productContainer);
        const isEditCart = document.querySelector('.page-cart-show .edit-product-modal > .modal-overlay.is-open');
        if(isEditCart) {
          // Switch add to cart and notify me based on availability
          const notifyAndAddToCart = $productContainer.find('.js-add-to-cart-actions');
          if (notifyAndAddToCart) {
            if (notifyAndAddToCart.hasClass('show-notify-me') && data.product.available) {
              notifyAndAddToCart.removeClass('show-notify-me');
            } else if (!notifyAndAddToCart.hasClass('show-notify-me') && !data.product.available) {
              notifyAndAddToCart.addClass('show-notify-me');
            }
          }
        }
        $('body').trigger('product:afterAttributeSelect', { data: data, container: $productContainer });

        // if(window.isMobile()) {
        //   jQuery('.owl-carousel').trigger('destroy.owl.carousel').removeClass('owl-carousel owl-loaded');
        //   jQuery('.owl-carousel').find('.owl-stage-outer').children().unwrap();

        //   jQuery(".product-detail .primary-images .carousel").addClass("owl-carousel");
        //   var carousel = jQuery(".product-detail .primary-images .carousel").owlCarousel({
        //       loop: true,
        //       nav: true,
        //       dots: false,
        //       items: 1,
        //       navText: [],
        //   });

        //   $(".primary-images .zoom").data("current-item", 0);
        // }
      }
    });
  }
}
/**
 * updates the product view when a product attribute is selected or deselected or when
 *         changing quantity for Shop the look products
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {jQuery} $productContainer - DOM element for current product
 */
 function attributeSelectStl(selectedValueUrl, $productContainer) {
  if (selectedValueUrl) {
    $.spinner().start();
    $('body').trigger('product:beforeAttributeSelect', { url: selectedValueUrl, container: $productContainer });

    $.ajax({
      url: selectedValueUrl,
      method: 'GET',
      success: function (data) {
        let cartActions = $productContainer.find('.js-add-to-cart-actions');
        let wishlistActions = $productContainer.find('.js_add-to-wish-list');

        // change the id of the variation for each size
        if (cartActions && data && data.product && data.product.id) {
          cartActions.attr('data-pid', data.product.id);
        }

        if (wishlistActions && data && data.product && data.product.id) {
          wishlistActions.attr('data-pid', data.product.id);
        }

        // Switch add to cart and notify me based on availability
        const notifyAndAddToCart = $productContainer.find('.add-to-cart-switch');
        if (notifyAndAddToCart) {
          if (notifyAndAddToCart.hasClass('show-notify-me') && data.product.available) {
            notifyAndAddToCart.removeClass('show-notify-me');
          } else if (!notifyAndAddToCart.hasClass('show-notify-me') && !data.product.available) {
            notifyAndAddToCart.addClass('show-notify-me');
          }
        }

        // Update wishlist icon
        const $addTowishListIcon = $productContainer.find('.js_add-to-wish-list');

        if ($addTowishListIcon.length > 0 && data.product && data.product.id) {
          $addTowishListIcon.toggleClass('active', data.product.inWishList);
          $addTowishListIcon.attr('data-pid', data.product.id);
        }

        $('body').trigger('product:afterAttributeSelect', { data: data, container: $productContainer });
        $.spinner().stop();
      },
      error: function () {
        $.spinner().stop();
      },
    });
  }
}

/**
 * Updates the availability status in the Product Detail Page
 *
 * @param {Object} response - Ajax response object after an
 *                            attribute value has been [de]selected
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function updateAvailability(response, $productContainer) {
  let availabilityValue = '';
  const availabilityMessages = response.product.availability.additionalMessages;
  let messages= document.querySelector('.js-additional-messages');
  availabilityMessages.forEach(function (message) {
    availabilityValue += `<div class="additional-msg mm-form-message -info mb-0.5">
                            <p class="m-0">${message}</p>
                          </div>`
  });
  messages.innerHTML = availabilityValue
  availabilityValue = '';

  $($productContainer).trigger('product:updateAvailability', {
    product: response.product,
    $productContainer: $productContainer,
    message: availabilityValue,
    resources: response.resources,
  });

  // update notifyme
}

/**
 * Updates the recommendation carousel in the Product Detail Page
 *
 * @param {Object} response - Ajax response object after the
 *                            render of new recommendations
 */
 function updateStlRecommendations(response) {
  if (response && response.queryString && response.product && response.product.stlProductsRecommendations) {
    var updateRecommendationUrl = $('.stl-update-recommendation').data('action');

    if (updateRecommendationUrl) {
      updateRecommendationUrl = updateRecommendationUrl + '?' +  response.queryString;

      $.ajax({
        url: updateRecommendationUrl,
        method: 'GET',
        success: function (data) {
          if (data) {
            // repopulate the carousel
            $('.stl-update-recommendation').html(data)

            productRecommendationsCarousel();
          }
        }
      });
    }
  }
}

/**
 * Parses JSON from Ajax call made whenever an attribute value is [de]selected
 * @param {Object} response - response from Ajax call
 * @param {jQuery} $productContainer - DOM element for a given product.
 */
function handleVariantResponse(response, $productContainer) {
  // Update variation attributes
  if (response.product && response.product.variationAttributes) {
    updateAttrs(response.product.variationAttributes, $productContainer, response.resources, response.product.localizedSizes);
  }

  // Update product name and number
  updateProductDetails(response.product.defaultVariant ? response.product.defaultVariant : response.product, $productContainer);

  // Update size warning
  let warningSizeWrapper = document.querySelector('.product-size-message-warning-inner', $productContainer);
  let warningSizeWrapperContainer = document.querySelector('.product-size-message-warning', $productContainer);
  if (response.sizeMsg){
    warningSizeWrapperContainer.classList.remove('visually-hidden');
    var warningMsg = `<div class="jil-form-message mb-1">${response.sizeMsg}</div>`;

    warningSizeWrapper.innerHTML = warningMsg;
  }
  else {
    warningSizeWrapperContainer.classList.add('visually-hidden');
    warningSizeWrapper.innerHTML = '';
  }

  const $responseProductID = response.product && response.product.id;
  const $wishlistButton = $('.add-to-wish-list.js_add-to-wish-list');
  if($responseProductID && $wishlistButton) {
    // update add to wishlist button's pid attribute
    $wishlistButton.attr('data-pid', $responseProductID);
    // update active class if new product is in wishlist
    $wishlistButton.toggleClass('active', response.product.inWishList);
  }
  // update add to cart button's pid attribute
  const $addToCartBtn = $('.add-to-cart.js-add-to-cart ');
  $addToCartBtn && $addToCartBtn.attr('data-pid', $responseProductID);

  // Update pricing
  let $priceSelector = $('.prices .price', $productContainer).length ? $('.prices .price', $productContainer) : $('.prices .price');
  if (response.product.variationGroupPrice && response.product.variationGroupPrice.html ) {
    $priceSelector.replaceWith(response.product.variationGroupPrice.html);
  } else if (response.product && response.product.defaultVariant && response.product.defaultVariant.price && response.product.defaultVariant.price.html) {
    $priceSelector.replaceWith(response.product.defaultVariant.price.html);
  } else if (response.product && response.product.price && response.product.price.html) {
    $priceSelector.replaceWith(response.product.price.html);
  }

  const uniqueSizeAddToCartBtn = document.querySelector('.unique-size-product-wrapper .add-to-cart');
  uniqueSizeAddToCartBtn && uniqueSizeAddToCartBtn.classList.add('--blue');

  // Update images
  // TODO remove to remove error
  updateImages(response.product);

  // Update availability
  updateAvailability(response, $productContainer);

  // Update Shop the Look Recommendations
  updateStlRecommendations(response);

  // manage bopis
  let bopisBtn = $('button.bopis-btn');
  bopisBtn && bopisBtn.attr('data-pid', $responseProductID);

  let bopisModalErrorMessage = document.querySelector('#product-show .store-item .item-error-message-container');
  bopisModalErrorMessage ? bopisModalErrorMessage.innerText = '' : null ;

  // update preorder
  updatePreorderDetails(response.product.defaultVariant ? response.product.defaultVariant : response.product, $productContainer);

  // Enable "Add to Cart" button if all required attributes have been selected
  function addToCartBehaviour() {
    let addToCartBtn = $('.js-add-to-cart-actions');
    const notifyAndAddToCart = $('.prices-add-to-cart-actions');
    // const estimatedDelivery = document.querySelector('.pdp-estimate-delivery');
    addToCartBtn.trigger('product:updateAddToCart', {
      product: response.product,
      $productContainer: $productContainer,
    });
    const isCart = document.querySelector('#maincontent #cart');
    if(!isCart) {
      // loop notifyandaddtocart
      notifyAndAddToCart.each(function() {
        this.classList.toggle('show-notify-me', !(response.product.available));
      });
      // notifyAndAddToCart.toggle('show-notify-me', !(response.product.available));
      // estimatedDelivery.classList.toggle('-hide', !(response.product.available));
      // estimatedDelivery.classList.toggle('-show', (response.product.available));
      if(response.product.notifyMePDPctaText) {
        const pdpNotifyMeButton = document.querySelector('#pdp-notify-me-nutton');
        if(pdpNotifyMeButton)  {
          pdpNotifyMeButton.textContent = response.product.notifyMePDPctaText;
        }
      }
    }
  }

  addToCartBehaviour();

  // const $pickUpInStore = $productContainer.find('.findinstore .bopis-btn');
  // const $notifyProduct = $productContainer.find('.prices-add-to-cart-actions .js-notify-me-button');

  // Update wishlist icon
  const $addTowishListIcon = $productContainer.find('.js_add-to-wish-list');

  if ($addTowishListIcon.length > 0) {
    $addTowishListIcon.toggleClass('active', response.product.inWishList);
    $addTowishListIcon.attr('data-pid', response.product.id);
  }

  let lastAction = $('.last-action-tracker').data('lastAction');
  if (lastAction != '' && lastAction != undefined) {
    if (lastAction == 'add-to-wishlist') {
      $addTowishListIcon.trigger('click');
      $('#size-selector-modal .prices-add-to-cart-actions.add-to-cart-actions.js-add-to-cart-actions').removeClass('is-hidden');
      $('#size-selector-modal .findinstore').removeClass('is-hidden');
    }
    // if (lastAction == 'pickup-instore') {
    //   $pickUpInStore.trigger('click');
    // }
    $('.last-action-tracker').data('lastAction', '');
    $('#size-selector-modal.is-open').removeClass('is-open');
    $('body').removeClass('no-zindex');
    updateBodyScrollability();
  }

  // if (response.product.backInStockNotificationEnabled && !response.product.available) {
  //   $('#size-selector-modal.is-open').removeClass('is-open');
  //   $notifyProduct.trigger('click');
  // }

  // ProductDetail.showSlider();

  updateSizeSelectorSizing();
}

function updateAttrsData (element, attr) {

  element.attr('data-href',attr.url);

  if (!attr.selectable) {
    // $attrValue.text(attrValue.displayValue + ' ' + msgs.variationUnavailable);
    element.addClass('disabled');
  } else {
    element.text(attr.displayValue);
    element.removeClass('disabled');
  }

  if (attr.selected) {
    element.prop('selected', true);
    element.addClass('selected');
    element.parent().addClass('selected');
  } else {
    element.removeAttr('selected');
    element.removeClass('selected');
    element.parent().removeClass('selected');
  }
}

/**
 * Process attribute values associated with an attribute that does not have image swatches
 * @param {Object} attrs - Attributes
 * @param {jQuery} $productContainer - DOM container for a given product
 * @param {Object} msgs - object containing resource messages
 */
function updateAttrs(attrs, $productContainer, msgs, localizedSizes) {
  let $attributeValues;
  attrs.forEach((attr) => {

    if(attr.attributeId == 'color'){

      $attributeValues = $('.js-wrapper-colors');
      attr.values.forEach(function (attrValue) {
        $attrValue = $attributeValues.find('[data-value-id="value-'+ attrValue.id + '"]');

        if (attrValue.selected) {
          $attrValue.prop('checked', true);
          $attrValue.attr('checked');
          $attrValue.addClass('selected-color');
          $attrValue.closest('.color-attribute').addClass('disable-color-attribute');
          $('.selected-color-container .selected-color-container-value').empty().text(attrValue.displayValue);
        } else {
          $attrValue.prop('checked', false);
          $attrValue.removeAttr('checked');
          $attrValue.removeClass('selected-color');
          $attrValue.closest('.color-attribute').removeClass('disable-color-attribute');
        }
      });

    }
    if(attr.attributeId == 'size'){
      // $attributeValues = $productContainer.find('.select-' + attr.id);
      attr.values.forEach(function (attrValueCheck) {
        // if attrValueCheck is selected change text to displayValue
        if (attrValueCheck.selected) {
          $('.dropdown-trigger.size-selector-button .psize-selector span').text(attrValueCheck.displayValue);
          $('.dropdown-trigger.size-selector-button .psize-selector').removeClass('-medium-grey');
        }
      });

      $attributeValues = $('.product-detail');

      let $attrValue;
      if (localizedSizes.length) {
        localizedSizes.forEach(function (localizedSize) {
          localizedSize.values.forEach(function (attrValue) {
            let $attributeValuesJS = $attributeValues.find('[data-size-country="' + localizedSize.label + '"]');;
            $attrValue = $attributeValuesJS.find('[data-attr-value="' + attrValue.id + '"]');
            updateAttrsData($attrValue, attrValue);

          });
        });
      } else {
        attr.values.forEach(function (attrValue) {
          $attrValue = $attributeValues.find('[data-attr-value="' + attrValue.id + '"]');
          updateAttrsData($attrValue, attrValue);
        });
      }
    }
  });
}

/**
 * Process attribute values associated with an attribute that does not have image swatches
 * @param {Object} product - Product
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function updateProductDetails(product, $productContainer) {
  // Update product number
  // Update product name
  // Update product description
  $productContainer.find('.js-product-id-content').text(product.modelFabricColor);
  $productContainer.find('.js-product-name').text(product.productNamePDP);
  $productContainer.find('.js-description-content').html(product.productDescriptionLong);

  // removed update breadcrumb last element,is not showed in pdp JILS-57

  // TODO need to check jil structure and if need to be done
  // Update accordion details
  let careInstructionsParagraph = $productContainer.find('.js-sustainable-description');
  if (careInstructionsParagraph) {
    careInstructionsParagraph.text(product.careInstsustainableructions);
  }

  let editorialCompositionParagraph = $productContainer.find('.js-editorial-composition-description');
  if (editorialCompositionParagraph) {
    editorialCompositionParagraph.text(product.editorialComposition);
  }

  let sizeAndFitParagraph = $productContainer.find('.js-size-and-fit-note-list');
  if (sizeAndFitParagraph) {
    let sizeGuidelinesLI = $productContainer.find('.js-size-and-fit-note-list .size-guidelines-li');
    sizeGuidelinesLI.length > 0 ? sizeAndFitParagraph.find(' li:not(.size-guidelines-li, .sizing-type-item)').remove() :  sizeAndFitParagraph.html('');

    product.sizeAndFiteNotes.forEach(function (s) {
      sizeGuidelinesLI.length > 0 ? sizeGuidelinesLI.after('<li>' + s + '</li>') : sizeAndFitParagraph.append('<li>' + s + '</li>');
    });
  }

  let modelImageSizeColorParagraph = $productContainer.find('.js-model-image-size-color');
  if (modelImageSizeColorParagraph) {
    modelImageSizeColorParagraph.text(product.modelImageSizeColor);
  }

  const badgeContainer = $productContainer.find('.tile-badges');
  const badgeObject = product.BadgeObject;
  badgeContainer && badgeContainer.html('');
  let displayBadges = false;
  if (badgeContainer && badgeObject) {
    let badgeHTML = '';
    (badgeObject.textBadge && badgeObject.newArrival) && delete badgeObject.newArrival;
    Object.values(badgeObject).filter(b => b.show).forEach( badge => {
      badgeHTML += `<div class="product-badge" ${badge.style}>${badge.text}</div>`;
      displayBadges = true;
    });
    badgeContainer.html(badgeHTML);
  }
  badgeContainer.toggleClass('d-none', !displayBadges);
}


function updatePreorderDetails(product, $productContainer){
  if (product.isPreOrder){
    // Update date
    $productContainer.find('span.productPreorderReleaseDate').text(product.preorderReleaseDate);

    const preorderItems = [...document.querySelectorAll('.js-preorder-item')];
    preorderItems.forEach((item) => {
      item.classList.add('-show');
      item.classList.remove('-hide');
    });

    const normalbuyItems = [...document.querySelectorAll('.js-normal-buy-item')];
    normalbuyItems.forEach((item) => {
      item.classList.add('-hide');
      item.classList.remove('-show');
    });

  } else {

    const preorderItems = [...document.querySelectorAll('.js-preorder-item')];
    preorderItems.forEach((item) => {
      item.classList.add('-hide');
      item.classList.remove('-show');
    });

    const normalbuyItems = [...document.querySelectorAll('.js-normal-buy-item')];
    normalbuyItems.forEach((item) => {
      item.classList.add('-show');
      item.classList.remove('-hide');
    });

  }

}

function compileImageTemplate(template, img, index,isZoom) {
  const productSlide = template.cloneNode(true);
  productSlide.dataset.index = index;

  const productImg = productSlide.querySelector('img');
  // productImg.dataset.zoomImg = img.url;
  productImg.alt = img.alt;
  productImg.title = img.title;
  productImg.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 3 4'%3E%3C/svg%3E";
  productImg.dataset.index = index;

  productImg.dataset.srcset =isZoom ? img.url: img.urlLarge;
  // let srcSetString = '';
  //

  // productImg.dataset.srcset.split(',').forEach((w,i) => {
  //   if (w.includes('x')){
  //     const width = productImg.dataset.formats.split(',')[i]; //get the first numeric part
  //     const retina = w.match(/(\d+)x/)[1]; //get the numeric part before 'x'
  //     srcSetString += `${img.dis[width]} ${retina}x,`
  //   } else if (w.includes('w')){
  //     const width = w.match(/(\d+)w/)[1];; //get the numeric part before 'w'
  //     srcSetString += `${img.dis[width]} ${width}w,`
  //   }
  // });

  // productImg.dataset.srcset = srcSetString;
  // productImg.srcset = srcSetString;
  return productSlide;
}


function updateImages(product) {
  var swiper = document.querySelector('.carousel-wrapper').querySelectorAll('.swiper-container')[0].swiper;
  swiper.destroy(true, false);
  const productData = product.defaultVariant ? product.defaultVariant : product;

  // js-pdp-image-carousel
  const productSlideTemplate = document.querySelector('#carousel-image-template .js-carousel-item');
  const productSlideZoomTemplate = document.querySelector('#carousel-image-zoom-template .js-carousel-item-zoom');
  const imagesWrapper = document.querySelector('.js-swiper-wrapper.swiper-wrapper.image-wrapper');
  const imagesWrapperZoom = document.querySelector('.js-zoom-wrapper');
  const imageZoomTemplate = document.querySelector('#carousel-image-zoom-template-wrapper').innerHTML;

  if(window.isMobile()) {
    let height =  $(imagesWrapper).height();
    $(imagesWrapper).css('height', height + "px");
  }

  imagesWrapper ? imagesWrapper.innerHTML = '' : null;
  imagesWrapperZoom ? imagesWrapperZoom.innerHTML = '' : null;

  productData.swipeableImages.large.forEach((img, index) => {
    imagesWrapper && imagesWrapper.append(compileImageTemplate(productSlideTemplate, img, index));
  });

  imagesWrapperZoom.insertAdjacentHTML('afterbegin', imageZoomTemplate);
  $('.unstyled-list.js-zoom-carousel.js-swiper-wrapper.swiper-wrapper').empty();

  productData.swipeableImages.large.forEach((img, index) => {
    $('.unstyled-list.js-zoom-carousel.js-swiper-wrapper.swiper-wrapper').append(compileImageTemplate(productSlideZoomTemplate, img, index,true));
  });


  // IBT-3745
  const imagesWrappers = document.querySelector('.carousel-wrapper').querySelectorAll('.swiper-wrapper');
  imagesWrappers.forEach(element => {
    if (element === imagesWrapper) return;
    element.innerHTML = imagesWrapper.innerHTML;
  });

  //TODO: Check Marni for video and editorial images
  // const swiper = thumbsWrapper.closest('.swiper').swiper;
  zoomAddToCartClick();

  const settings = {
    direction: 'horizontal',
    spaceBetween: 0,
    centeredSlides: true,
    slidesPerView: 1,
    observer: true,
    observeParents: true,
    speed: 800,
    mousewheel: true,
    shortSwipes: true,
    touchMoveStopPropagation: true,
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      576: {
        direction: 'horizontal',
        spaceBetween: 8,
        centeredSlides: false,
        slidesPerView: 'auto',
        speed: 800,
        observer: true,
        observeParents: true,
        pagination: {
          el: '.swiper-pagination-jilpdp',
          clickable: true,
          type: 'bullets',
        },
      },
      768: {
        direction: 'vertical',
        spaceBetween: 8,
        centeredSlides: false,
        slidesPerView: 1,
        speed: 800,
        observer: true,
        observeParents: true,
        pagination: {
          el: '.swiper-pagination-jilpdp',
          clickable: true,
          type: 'bullets',
        },
      },
      992: {
        direction: 'horizontal',
        spaceBetween: 20,
        centeredSlides: false,
        slidesPerView: 2,
        speed: 800,
        observer: true,
        observeParents: true,
        pagination: false,
      },
    },
    effect: 'slide'
  };

  const swiper2 = new Swiper('.product-slider-container', settings);

  $('.zoom-wrapper.js-zoom-wrapper').addClass('imagesUpdated');
}

/**
 * Show validation popup
 * @param {Objecct} responseData response data
 */
function showNotificationPopup(responseData) {
  if (responseData) {
    let validationPopup;
    const findInStore = $('#findInStoreModal');

    if (responseData.sameProductError) {
      if (responseData.sameProductReason === 'addedForDelivery') {
        validationPopup = $('.js_addedForDelivery');
      } else if (responseData.sameProductReason === 'alreadyCustomized') {
        validationPopup = $('.js_alreadyCustomized');
      } else {
        validationPopup = $('.js_addedForPickup');
      }
    } else if (responseData.preorderProductError) {
      validationPopup = $('.js_addedForPreorder');
    } else if (responseData.giftcardError) {
      validationPopup = $('.js_giftcard__modal-error-cart');
    }

    if (validationPopup && validationPopup.length > 0) {
      findInStore.modal('hide');
      validationPopup.modal('show');
    }
  }
}

/**
 * Call add to cart
 *
 * @param {string} productId
 */
function submitProductToCart(productId) {
  // console.log('submitProductToCart', productId);

  if ($('.selected-color').length>0 && $('.do_selectsize.selected').length>0) {
    $('.js-addtocart-error').addClass('is-hidden');

    if ($('.zoom-wrapper.isOpen').length > 0 || $('#size-selector-modal.is-open').length > 0) {
      const zoomWrapper = $('.zoom-wrapper.isOpen');
      zoomWrapper.removeClass('isOpen');
      const sizeSelectorModal = $('#size-selector-modal.is-open');
      sizeSelectorModal.removeClass('is-open');

      $('body').removeClass('no-zindex');
    }

      if ($('.vto-zoom-wrapper.isOpen').length > 0) {
          const vtoZoomWrapper = $('.vto-zoom-wrapper.isOpen');
          vtoZoomWrapper.removeClass('isOpen');
          $('body').removeClass('no-zindex');
      }

  } else {
    let addToCartError = $('.js-addtocart-error').data('addtocart-alert');
    // $('.js-addtocart-error').removeClass('is-hidden');
    // $('.js-addtocart-error-message').empty().append(addToCartError);

    if (isMobile) {
      $('.js-addtocart-error-message.addtocart-error-message.jil-form-message')[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    if ($('.selected-color').length < 1) {
      return;
    }

    if ($('.zoom-wrapper.isOpen').length > 0) {
      const zoomWrapper = $('.zoom-wrapper.isOpen');
      zoomWrapper.removeClass('isOpen');
    }

      if ($('.vto-zoom-wrapper.isOpen').length > 0) {
          const zoomWrapper = $('.vto-zoom-wrapper.isOpen');
          zoomWrapper.removeClass('isOpen');
      }

    $('.size-selector-trigger-box .size-selector-button').click();

    return;
  }

  $.spinner().start();
  const addToCartUrl = $('.add-to-cart-url').val();

  if (addToCartUrl && productId) {
    const form = {
      pid: productId,
      quantity: 1,
    };
    const errorBox = document.querySelector('.details-column-content .add-to-cart-error-messaging');
    $.ajax({
      url: addToCartUrl,
      method: 'POST',
      data: form,
      success: function (responseData) {
        if (!responseData.error) {
          // Tealium event "Cart Addition"
          $('body').trigger('product:afterAddToCart', responseData);

          $(".minicart").trigger("count:update", responseData);

          // if (["small", "medium"].indexOf(Foundation.MediaQuery.current) === -1) {
          //   $(".minicart .nav-item-title").trigger("click:minicart");
          // } else {
          if (isMobile) {
            // show notification
            const event = new CustomEvent('notification:show', {
              detail: {
                message: responseData.message,
                icon: true,
                linkCart: true,
                linkWishlist: false,
                linkCheckout: true,
                addToCartContent: responseData.addToCartContent
              }
            });
            document.body.dispatchEvent(event);
          } else {
            $('.mini-cart-content, .minicart-backdrop').addClass('show');
            $('.menu-background-overlay').addClass('is-visible');

            $('.nav-primary').addClass('secondary-open');
            if ($('#menu').hasClass('headspace--hidden')) {
              $('#menu').addClass('minicart-is-open');
              $('#menu').removeClass('headspace--hidden');
            }
            document.documentElement.classList.toggle('overflow-hidden', true);
          };
          $('body').trigger('minicart:load');

          // Close minicart
          $('.minicart-backdrop, .continue-shopping-btn').on('click', () => {
              $('.mini-cart-content, .minicart-backdrop').removeClass('show').hide();
              $('.menu-background-overlay').removeClass('is-visible');
              document.documentElement.classList.toggle('overflow-hidden', false);
              if ($('#menu').hasClass('minicart-is-open')) {
                $('#menu').removeClass('minicart-is-open');
              }
          });
          // }

          //
          // Open minicart
          // $('.minicart-action').trigger('click');
          // const mincartButtons = [...document.querySelectorAll('.js-button-minicart')];
          // mincartButtons.forEach((item) => {
          //   item.classList.contains('-dot-info') ? null : item.classList.add('-dot-info');
          // });
          !errorBox.classList.contains('d-none') ? errorBox.classList.add('d-none') : '';
        } else {
          showNotificationPopup(responseData);
          if(errorBox){
            errorBox.classList.remove('d-none');
          }
          $('.details-column-content .add-to-cart-error-messaging > div').text(responseData.message);
        }

        $.spinner().stop();
      },
      error: function () {
        $.spinner().stop();
      },
    });
  }
}

/**
 * Init Product Recommendations Carousel
 *
 */
 function productRecommendationsCarousel() {
    var numberOfSlides = $('[data-number-of-slides]').length ? $('[data-number-of-slides]')[0].dataset.numberOfSlides : 0;

   if (numberOfSlides >= 6) {
    const settings = {
      slidesPerView: 1,
      observer: true,
      loop: true,
      spaceBetween: 8,
      createElements: true,
      centeredSlides: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        640: {
          slidesPerView: 5,
          loop: true,
          spaceBetween: 8,
          centeredSlides: false
        }
      }
    };

    const swiper = new Swiper('.product-carousel-products-init', settings);

    swiper.init();
   } else {
    const settings = {
      slidesPerView: 1,
      observer: true,
      loop: true,
      spaceBetween: 8,
      createElements: true,
      centeredSlides: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        640: {
          slidesPerView: 5,
          watchOverflow: true,
          loop: false,
          spaceBetween: 8,
          centeredSlides: false
        }
      }
    };

    const swiper = new Swiper('.product-carousel-products-init', settings);

    swiper.init();
   }
}

// function colorWrapperWidthHandles() {
//   const selectedAssistiveText = document.querySelector('.dynamic-selected-assistive-text-width .selected-assistive-text');
//   const width = (selectedAssistiveText && selectedAssistiveText.clientWidth && selectedAssistiveText.clientWidth) + 8 || 0;
//   debugger;
//   document.documentElement.style.setProperty('--colors-box-margin-right', width + 'px');
// }

function initModules() {
  updateCountrySelector();
  updateSizeSelectorSizing();
  // colorWrapperWidthHandles();

  // on click size

  $('.dropdown-trigger.size-selector-button').on('click', function(e){
    updateSizeSelectorSizing();
  });

  $('.pdp-size-picker.pdp-size-picker-drawer .findinstore').on('click', function(e){
    $('#size-selector-modal').removeClass('is-open');
    $('body').removeClass('no-zindex');
    updateBodyScrollability();
    $('.main-findinstore .bopis-btn').click();
  });


  // $('.modal-close').on('click', function(e){
  //   var scrollTop = $('.scroll-distance').data('scrolledDistance');
  //   let body = document.getElementsByTagName('body')[0];
  //   body.setAttribute("style", "overflow-y: scroll; position: unset; width:100%; height: 100vh;");
  //   if (scrollTop) {
  //     window.scrollTo(0, scrollTop);
  //   }
  // });

}

function selectColorAttrributeClick() {
  document.querySelectorAll('.color-attribute:not(disable-color-attribute) .js-swatch-circle').forEach(swatch => {
    swatch.addEventListener('click', (e) => {
      const isCart = document.querySelector('body.page-cart-show');
      if(e.target) {
        let $productContainer = $(e.target).closest('.set-item');
        if (!$productContainer.length) {
          $productContainer = $(e.target).closest('.product-detail');
        }
        if(isCart) {
          $productContainer = $(e.target).closest('.edit-product-modal');
        }
        // $(this).parent().removeClass('invalid');
        attributeSelect(e.target.dataset.url, $productContainer);
      }
    })
  });
}

function doSelectSizeClick() {
  $('.do_selectsize').on('click', function(e){
    // e.preventDefault();

    let isStlSelectAttribute = false;
    // let dataValue = e.currentTarget.href;
    let dataValue = e.currentTarget.dataset.href;

    // Check if it's a shop the look prd
    let shopTheLookPDP = $(this).closest('.stl-pdp');
    if (shopTheLookPDP && shopTheLookPDP.find('.js-add-to-cart-actions').length > 0) {
      let cartActions = shopTheLookPDP.find('.js-add-to-cart-actions');
      if (cartActions.attr('data-stl-add-to-cart') === 'true') {
        isStlSelectAttribute = true;
      }
    }
    // It's a shop the look prd
    if (isStlSelectAttribute) {
      let $productContainerStl = $(this).closest('.stl-pdp');
      attributeSelectStl(dataValue, $productContainerStl);
    } else {
      let $productContainer = $(this).closest('.set-item');
      if (!$productContainer.length) {
        const productDetailElement = $(this).closest('.product-detail');
        $productContainer = productDetailElement.length > 0 ? productDetailElement : $(this).closest('.modal-content');
      }
      $(this).parent().removeClass('invalid');
      attributeSelect(dataValue, $productContainer);
    }
  });
}

function zoomAddToCartClick() {
  $('.zoom-wrapper .js-add-to-cart-actions').on('click', function (e) {
    $('body').removeClass('no-zindex');
    $('body').trigger('product:beforeAddToCart', this); // eslint-disable-line no-undef
    // Check if it's a shop the look prd
    if ($(this).attr('data-stl-add-to-cart') === 'true') {
      let $productContainerStl = $(this).closest('.stl-pdp');

      if (addToCartValidation($productContainerStl)) {
        submitProductToCart($(this).attr('data-pid'));
      }
    } else {
      let $productContainer = $(this).closest('.product-detail');
      if (addToCartValidation($productContainer)) {
        submitProductToCart($('.js-add-to-cart').attr('data-pid'));
      }
    }
  });
}

function addToCartClick() {
  $('.js-add-to-cart-actions').on('click', function (e) {
    $('body').removeClass('no-zindex');
    $('body').trigger('product:beforeAddToCart', this); // eslint-disable-line no-undef
    // Check if it's a shop the look prd
    if ($(this).attr('data-stl-add-to-cart') === 'true') {
      let $productContainerStl = $(this).closest('.stl-pdp');

      if (addToCartValidation($productContainerStl)) {
        submitProductToCart($(this).attr('data-pid'));
      }
    } else {
      let $productContainer = $(this).closest('.product-detail');
      if (addToCartValidation($productContainer)) {
        submitProductToCart($('.js-add-to-cart').attr('data-pid'));
      }
    }
  });
}

function updateAddToCart() {
  $('.js-add-to-cart-actions').on('product:updateAddToCart', function (e, response) {
    const product = response.product;
    //const isMaster = product.productType === 'master';
    response.$productContainer.find('.js-add-to-cart').attr('data-pid', product.id);
    response.$productContainer.find('.js-add-to-cart').addClass('--blue');
    if ($('.selected-color').length>0 && $('.do_selectsize.selected').length>0) {
      $('.js-addtocart-error').addClass('is-hidden');
    }
  });
}

$('body').on('cart:edit-modal-open', function() {
  // console.log('edit modal open');
  doSelectSizeClick();
  selectColorAttrributeClick();
  addToCartClick();
});

function updateCountrySelector() {
  const pid = document.querySelector('.product-detail') && document.querySelector('.product-detail').getAttribute('data-pid');
  if (pid) {
    let countrySelectorHeader = document.querySelectorAll('.js-button-country');
    countrySelectorHeader.forEach(function(item){
      item.setAttribute('data-query-param',pid);
      item.setAttribute('data-query-param-type','pid');
    });
  }
}

function onScroll() {
  if (window.innerWidth < 576) {
    if (window.scrollY < 170) {
        $('.prices-add-to-cart-actions').removeClass('sticky-add-to-cart');
    } else {
        $('.prices-add-to-cart-actions').addClass('sticky-add-to-cart');
    }

    this.oldScroll = this.scrollY;

    // Sticky Header
    const header = $('.nav-mobile.headspace').addClass('headspace--pdp');
    const galleryHeight = $('.product-detail.product-wrapper .product-slider-container').height();

    if (window.scrollY > galleryHeight - 50) {
      header.addClass('hidden');
    } else {
      header.removeClass('hidden')
    }
  }
}

module.exports = {
  bindEvents: function(){
    if(document.readyState !== 'loading') {
      initModules();
    }
    else {
      document.addEventListener("DOMContentLoaded",function(){
        initModules();
      });
    }
    selectColorAttrributeClick();
  },

  updateAddToCart: function () {
    updateAddToCart();
  },
  addToCart: function () {
    $('.js-toggle-details').on('click', function(e){
      $('.js-content-product-info').trigger('click');


      if (window.isMobile()) {
        $('html, body').animate({
          scrollTop: $(".js-content-product-info").offset().top
        }, 2000);
      }

      return false;
    });
    doSelectSizeClick();
    addToCartClick();
  },
  switchSizes: function () {
    $('.size-locale-option').on('click', function(e){
      // get data-size-country of e and look for the same data-size-country inside .pdp-size-picker container
      const sizeCountry = e.currentTarget.dataset.sizeCountry;
      const sizeCountryElements = document.querySelectorAll('.pdp-size-picker.pdp-size-picker-drawer [data-size-country]');
      const sizeCountryElementsPicker = document.querySelectorAll('.size-locale-selector [data-size-country]');
      sizeCountryElementsPicker.forEach(function(element){
        element.classList.remove('selected');
      });

      sizeCountryElements.forEach(function(element){
        if (element.dataset.sizeCountry === sizeCountry) {
          element.classList.remove('visually-hidden');
        } else {
          element.classList.add('visually-hidden');
        }
      });

      e.currentTarget.classList.add('selected');
    });
  },

  scrollToRecommendations: function () {
    $('.recommendation-section-trigger').on('click', function(e){
      e.preventDefault();
      document.querySelector('#recommendations-section').scrollIntoView({
        behavior: 'smooth'
      });
    });
  },

  switchSizesFitGuide: function () {
    $('.fitguide-size-locale-option').on('click', function(e){
      // get data-size-country of e and look for the same data-size-country inside .pdp-size-picker container
      const sizeCountry = e.currentTarget.dataset.sizeCountry;
      const sizeCountryElements = document.querySelectorAll('.modal-content-gudielines .table-details [data-size-country]');
      const sizeCountryElementsPicker = document.querySelectorAll('.fitguide-size-locale-selector [data-size-country]');
      sizeCountryElementsPicker.forEach(function(element){
        element.classList.remove('selected');
      });

      sizeCountryElements.forEach(function(element){
        if (element.dataset.sizeCountry === sizeCountry) {
          element.classList.remove('visually-hidden');
        } else {
          element.classList.add('visually-hidden');
        }
      });

      e.currentTarget.classList.add('selected');
    });
  },
  // modalClose: function () {
  //   $('.modal-close').on('click', function(e){
  //     var scrollTop = $('.scroll-distance').data('scrolledDistance');
  //     let body = document.getElementsByTagName('body')[0];
  //     body.setAttribute("style", "overflow-y: scroll; position: unset; width:100%; height: 100vh;");
  //     if (scrollTop) {
  //       window.scrollTo(0, scrollTop);
  //     }
  //   });
  // },
  // pickUpSizeSelector: function () {
  //   $('#size-selector-modal .bopis-btn').on('click', function(e){
  //     if ($('.selected-color').length>0 && $('.do_selectsize.selected').length>0) {
  //       var scrollTop = $('.scroll-distance').data('scrolledDistance');
  //       let body = document.getElementsByTagName('body')[0];
  //       body.setAttribute("style", "overflow-y: scroll; position: unset; width:100%; height: 100vh;");
  //       if (scrollTop) {
  //         window.scrollTo(0, scrollTop);
  //       }
  //       $('#size-selector-modal').removeClass('is-open');
  //       $('.bopis-btn').click();
  //     }
  //   });
  // },
  // updateMobileZoom: function () {
  //   var carousel = $(".product-detail .primary-images .carousel");

  //   carousel.on("changed.owl.carousel", function(event) {
  //     const index = $(".primary-images .carousel-item")
  //         .eq(event.item.index)
  //         .find("img")
  //         .eq(0)
  //         .data("index");
  //     $(".primary-images .zoom").data("current-item", index);
  //   })
  // },
  scrollButtonCta: function () {
    window.addEventListener('scroll', onScroll);
    onScroll();
  }
};
